export const FETCH_DASHBOARD = 'ipfabric/Dashboard/Overview/FETCH_DASHBOARD';
export const SWITCH_ACTIVE_LAYOUT =
  'ipfabric/Dashboard/Overview/SWITCH_ACTIVE_LAYOUT';
export const SWITCH_EDIT_LAYOUT_MODE =
  'ipfabric/Dashboard/Overview/SWITCH_EDIT_LAYOUT_MODE';
export const SAVE_LAYOUT = 'ipfabric/Dashboard/Overview/SAVE_LAYOUT';
export const DELETE_LAYOUT = 'ipfabric/Dashboard/Overview/DELETE_LAYOUT';
('ipfabric/Dashboard/Overview/DELETE_LAYOUT_START');
export const ADD_LAYOUT = 'ipfabric/Dashboard/Overview/ADD_LAYOUT';
export const RENAME_LAYOUT = 'ipfabric/Dashboard/Overview/RENAME_LAYOUT';
('ipfabric/Dashboard/Overview/RENAME_LAYOUT_START');
export const UPDATE_REPORT_GROUP =
  'ipfabric/Dashboard/Overview/UPDATE_REPORT_GROUP';
export const CREATE_REPORT_GROUP =
  'ipfabric/Dashboard/Overview/CREATE_REPORT_GROUP';
export const DELETE_REPORT_GROUP =
  'ipfabric/Dashboard/Overview/DELETE_REPORT_GROUP';
export const CLEAR_DASHBOARD = 'ipfabric/Dashboard/Overview/CLEAR_DASHBOARD';
export const FETCH_REPORTS = 'ipfabric/Dashboard/Overview/FETCH_REPORTS';
export const FETCH_DISCOVERY_HISTORY =
  'ipfabric/Dashboard/Overview/FETCH_DISCOVERY_HISTORY';
export const FETCH_NETWORK_VENDOR_MIX =
  'ipfabric/Dashboard/Overview/FETCH_NETWORK_VENDOR_MIX';
export const FETCH_HOST_VENDOR_MIX =
  'ipfabric/Dashboard/Overview/FETCH_HOST_VENDOR_MIX';
export const FETCH_TEXT_ROW = 'ipfabric/Dashboard/Overview/FETCH_TEXT_ROW';
export const UPDATE_COLUMN_PROPERTY =
  'ipfabric/Dashboard/Overview/UPDATE_COLUMN_PROPERTY';
export const ADD_ROW = 'ipfabric/Dashboard/Overview/ADD_ROW';
export const REMOVE_ROW = 'ipfabric/Dashboard/Overview/REMOVE_ROW';
export const REMOVE_WIDGET = 'ipfabric/Dashboard/Overview/REMOVE_WIDGET';
export const ADD_WIDGET = 'ipfabric/Dashboard/Overview/ADD_WIDGET';
export const UPDATE_WIDGET = 'ipfabric/Dashboard/Overview/UPDATE_WIDGET';
export const SORT_WIDGETS = 'ipfabric/Dashboard/Overview/SORT_WIDGETS';
export const MOVE_WIDGET = 'ipfabric/Dashboard/Overview/MOVE_WIDGET';
export const MOVE_COLUMN = 'ipfabric/Dashboard/Overview/MOVE_COLUMN';
export const SORT_COLUMNS = 'ipfabric/Dashboard/Overview/SORT_COLUMNS';
